"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = void 0;
var map;
function load(mapglURL) {
    if (mapglURL === void 0) { mapglURL = 'https://mapgl.2gis.com/api/js'; }
    if (typeof window === 'undefined') {
        throw new Error('mapgl is supported only in browser environment');
    }
    if (map) {
        return Promise.resolve(map);
    }
    return createScriptAndLoad(mapglURL).then(function () {
        map = window.mapgl;
        return map;
    });
}
exports.load = load;
function createScriptAndLoad(mapglURL) {
    return new Promise(function (resolve, reject) {
        // Create script element and set attributes
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = mapglURL;
        // Append the script to the DOM
        document.body.appendChild(script);
        // Resolve the promise once the script is loaded
        script.addEventListener('load', function () {
            resolve();
        });
        // Catch any errors while loading the script
        script.addEventListener('error', function (error) {
            reject(error);
        });
    });
}
